export enum OfferPath {
  TalentPool = 'talent_pools',
  Job = 'offers',
}

export enum OfferStatus {
  Draft = 'draft',
  Published = 'published',
  Internal = 'internal',
  Closed = 'closed',
  Archived = 'archived',
}

export enum OfferKind {
  Job = 'job',
  TalentPool = 'talent_pool',
}

export enum StatusChangeType {
  CreateJobTemplate = 'createJobTemplate',
  InsertFromTemplate = 'insertFromTemplate',
  Duplicate = 'duplicate',
  Unarchive = 'unarchive',
  Archive = 'archive',
  Delete = 'delete',
  Publish = 'publish',
  Unpublish = 'unpublish',
  Close = 'close',
  Draft = 'draft',
}

export enum JobIncludeParam {
  Counters = 'counters',
  Description = 'description',
  DynamicFields = 'dynamic_fields',
  FollowerIds = 'follower_ids',
  Highlight = 'highlight',
  Issues = 'issues',
  JobScheduler = 'job_scheduler',
  LocationIds = 'location_ids',
  Requirements = 'requirements',
  Salary = 'salary',
  Tags = 'tags',
  WorkModel = 'work_model',
}
